import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import TextareaAutosize from 'react-textarea-autosize'
import Loading from '../../Loading'
import { notify } from '../../../utils/util'
import { sendMessageToStudentFromFeedback } from '../../../server/server'

const MessageContainer = ({ feedback, setCurrentState = () => {}, messageSent = () => {} }) => {
    const { t } = useTranslation()
    const [privateMessage, setPrivateMessage] = useState('')
    const [sendMessageError, setSendMessageError] = useState(false)
    const [sendingMessage, setSendingMessage] = useState(false)

    const sendPrivateMessageToStudent = async () => {
        if (privateMessage === '') {
            setSendMessageError(true)
            return
        }
        setSendingMessage(true)
        const data = {
            feedback_id: feedback.id,
            message_body: privateMessage,
            created_date: Date.now(),
            ...feedback,
        }
        const resp = await sendMessageToStudentFromFeedback(data)
        if (resp.status === 200) {
            notify(t('messageHasBeenSent'))
            setCurrentState('init')
            setSendingMessage(false)
            messageSent(true)
        } else {
            setSendingMessage(false)
            notify(t('Error'))
        }
    }

    return (
        <div className="feedback-assigned-multiline" style={{ marginTop: 40 }}>
            <p className="feedback-take-action-title">{t('sendPrivateMessageToStudent')} </p>
            <div className="feedback-textarea" style={{ borderColor: sendMessageError ? '#FF747F' : '#bebece' }}>
                <TextareaAutosize
                    placeholder={t('writeYourMessageHere') + '...'}
                    minRows={4}
                    value={privateMessage}
                    id="action-message-textarea"
                    style={{ resize: 'none' }}
                    autoFocus
                    onChange={(e) => {
                        e.preventDefault()
                        setSendMessageError(false)
                        setPrivateMessage(e.target.value)
                    }}
                />
            </div>
            <p className="send-message-error" style={{ opacity: sendMessageError ? 1 : 0 }}>
                {t('youMustFillData')}
            </p>
            <div className="textarea-button" id="text-area-button" onClick={sendPrivateMessageToStudent}>
                {sendingMessage ? <Loading /> : <p>{t('submit')}</p>}
            </div>
        </div>
    )
}

export default MessageContainer
